import RequisitionsLinesForm from '../../../../components/Corporate/Requisitions/Lines/RequisitionsLinesForm'
import React from 'react'
import {Modal} from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function RequisitionsLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Requisitions Line'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <RequisitionsLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

RequisitionsLinesModal.propTypes = {}
RequisitionsLinesModal.defaultProps = {}

export default RequisitionsLinesModal
